<template lang="pug">
  .popup-product#popupProduct
    PreloaderImage
    .popup-product__wr(v-if="content")
      .popup-product__left
        .popup-product__slider(v-if="content.slider")
          .swiper-container
            .swiper-wrapper
              .swiper-slide(v-for="slide in content.slider", :key="slide.id", :style="`background-image: url(${slide.img});`")
            .swiper-pagination
            .swiper-button-prev
              SvgIcon(name="arrow", width="24", height="24")
            .swiper-button-next
              SvgIcon(name="arrow", width="24", height="24")
      .popup-product__right
        .popup-product__title(v-if="content.title") {{content.title}}
        .popup-product__text(v-if="content.text") {{content.text}}
        .popup-product__row
          .popup-product__size
            Select(v-if="content.size", :data="content.size", @setCurrentSelect="changePrice")
          .popup-product__counter
            button.popup-product__counter-button.popup-product__counter-button--dec(type="button" @click="changeCount($event, 'minus')", :class="{'popup-product__counter-button--disabled': content.count < 2}")
            input.popup-product__counter-input(type="number", min="1", v-model="content.count", maxlength="3")
            button.popup-product__counter-button.popup-product__counter-button--inc(type="button" @click="changeCount($event, 'plus')")
        .popup-product__card-old-price(v-if="content.oldPrice")
          span {{content.oldPrice.value}}
          | {{content.oldPrice.currency}}
        .popup-product__card-price(v-if="content.price")
          | {{content.price.value}}
          span {{content.price.currency}}
        button.popup-product__btn(v-if="content.btn", type="button", @click="addToCartLocal($event, content.id, content.count)") {{content.btn}}
</template>

<script>
  import EventBus from '@/eventBus';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {SliderHelpersVue} from '@/mixins/SliderHelpersVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';
  import Select from '@/components/common/select/select.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';

  // @ is an alias to /src
  import '@/components/common/popups/popupProduct/popupProduct.styl';

  export default {
    name: 'PopupProduct',

    mixins: [AjaxHelpersVue, SliderHelpersVue, CartHelpersVue],

    components: {
      SvgIcon,
      Select,
      PreloaderImage
    },

    data() {
      return {
        content: null
      }
    },

    created() {
      EventBus.$on('loadPopupProduct', params => {
        this.request(params);
      });

      EventBus.$on('clearPopupProduct', () => {
        this.content = null;
      });
    },

    methods: {
      request(params) {
        EventBus.$emit('preloaderShow', 'popup');

        this.req('MenuPage:getMenuPopup', {...params}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;
          }

          this.$nextTick(() => {
            this.initSlider('.popup-product__slider', {
              slidesPerView: 1,
              loop: false
            });

            setTimeout(() => {
              EventBus.$emit('preloaderHide', 'popup');
            }, 500);
          });
        }, '', 'localPageRequest');
      },

      changeCount(e, dir) {
        if(dir == 'plus') {
          this.content.count = +this.content.count + 1;
        } else if(dir == 'minus') {
          this.content.count = +this.content.count - 1;
        }
      },

      changePrice(res) {
        let params = {
          productId: this.content.id,
          size: res.value
        };

        this.req('MenuPage:changeProductPrice', {...params}, res => {
          if(this.checkProperty(res.status) && res.status == 'ok') {
            this.content.oldPrice = res.oldPrice;
            this.content.price = res.price;
          }
        }, '', 'localPageRequest');
      },

      addToCartLocal(e, productId, count) {
        let params = {
          productId: productId,
          count: count,
          size: $(e.target).parents('.popup-product__right').find('.PrologueUniVueComponentSelect__native').val()
        };

        this.addToCart((res) => {
          if(this.checkProperty(res.total)) {
            let count = res.total.count;

            this.$nextTick(() => {
              $('.header__cart-count').text(count);

              if(count > 0) {
                $('.header__cart-count').removeClass('header__cart-count--hide');
              } else {
                $('.header__cart-count').addClass('header__cart-count--hide');
              }

              let select = $('.popup-product').find('.PrologueUniVueComponentSelect__native').val();
              let params = {
                productId: this.content.id,
                count: this.content.count,
                oldPrice: this.content.oldPrice,
                price: this.content.price
              };

              this.content.size.options.forEach((el) => {
                if(el.value == select) {
                  params.size = el;
                }
              });

              EventBus.$emit('updateProduct', params);
              $.fancybox.close();
            });
          }
        }, params);
      },
    }
  }
</script>
